/**
 * Shared formatting helpers for the mobile activity log screens.
 *
 * Badge variants follow the contrast rules in CLAUDE.md: every variant returned
 * here is one of secondary/dark/success/danger/primary, so callers pair them
 * with `text-white`.
 */

export const formatDateTime = (value) => {
  if (!value) return '—';
  try {
    const d = new Date(value);
    return Number.isNaN(d.getTime()) ? value : d.toLocaleString();
  } catch (_) {
    return value;
  }
};

export const methodVariant = (method) => {
  switch (String(method || '').toUpperCase()) {
    case 'GET':
      return 'primary';
    case 'POST':
      return 'success';
    case 'PUT':
    case 'PATCH':
      return 'dark';
    case 'DELETE':
      return 'danger';
    default:
      return 'secondary';
  }
};

export const statusVariant = (statusCode) => {
  const code = Number(statusCode) || 0;
  if (code >= 500) return 'danger';
  if (code >= 400) return 'dark';
  if (code >= 200 && code < 400) return 'success';
  return 'secondary';
};

/**
 * Route actions arrive as a fully qualified controller name. The
 * `App\Http\Controllers\` prefix is identical on every row and is long enough
 * to force the detail modal into horizontal scrolling, so it is dropped.
 */
export const shortAction = (action) => {
  if (!action) return '—';
  return String(action).replace(/^App\\Http\\Controllers\\/, '');
};

/**
 * Payload columns come back as parsed JSON from Laravel's array cast, but a raw
 * string is still possible if the cast is bypassed.
 */
export const normalizeJson = (value) => {
  if (value == null) return null;
  if (typeof value === 'string') {
    try {
      return JSON.parse(value);
    } catch {
      return value;
    }
  }
  return value;
};
